import { useGameStore } from '../stores/gameStore';

export const GameUI = () => {
  const { phase, dailyMission } = useGameStore();

  // HUD is now drawn on canvas, this component is minimal
  if (phase !== 'playing' && phase !== 'paused') return null;

  return (
    <div className="game-ui-minimal">
      {!dailyMission.completed && dailyMission.target > 0 && (
        <div className="mission-indicator">
          {Math.max(0, dailyMission.target - (useGameStore.getState().score || 0))}pts left
        </div>
      )}
    </div>
  );
};

export default GameUI;
